import styled, { createGlobalStyle, css } from 'styled-components';

import { Button } from '@nw/omega-design-system';
import { colors } from '@nw/shared/ui';
import { maxDeviceWidth, mobile } from '@nw/shared/utils';

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Title = styled.p`
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 40px;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 32px;
  }
`;

export const TitleDescription = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #475569;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 20px;
  }
`;
export const EnrollmentFeeProfileAndCourseSection = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 24px 24px 12px;
  border-radius: 16px;
  background-color: ${colors['base-white']};

  ${mobile} {
    padding: 12px 16px;
  }
`;

export const TermsAndConditionsCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background-color: ${colors['light-blue-gray-50']};

  /* Hint reserves 20px when no error — collapse for enrollment terms checkboxes */
  .h-20px:empty,
  .text-input-hint:empty {
    display: none;
    height: 0 !important;
    min-height: 0;
    margin: 0;
    padding: 0;
  }
`;

export const EnrollmentCourseLockedField = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  min-width: 0;

  ${mobile} {
    gap: 8px;
  }
`;

export const EnrollmentCourseLockedIconWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  ${mobile} {
    width: 16px;
    height: 16px;
  }
`;

export const EnrollmentCourseLockedValueText = styled.span`
  flex: 1;
  min-width: 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${colors['light-red-900']};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${mobile} {
    font-size: 12px;
    line-height: 20px;
    white-space: normal;
    overflow-wrap: anywhere;
  }
`;

export const enrollmentCoursePickerFieldStyles = `
  box-sizing: border-box;
  width: 100%;

  .informed-select-label-text {
    display: block;
    margin-bottom: 8px;
    font-family: Inter;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: ${colors['light-blue-gray-700']};
  }

  @media (max-width: 767px) {
    .informed-select-label-text {
      display: none;
    }
  }
`;
export const EnrollmentPaymentSection = styled.div`
  box-sizing: border-box;
  width: 100%;
`;
export const EnrollmentFeeSectionHeading = styled.p`
  box-sizing: border-box;
  margin: 0;
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 40px;
  color: ${colors['light-blue-gray-700']};
  ${maxDeviceWidth(768)} {
    font-size: 20px;
    line-height: 32px;
  }
`;
export const EnrollmentCourseFieldContainer = styled.div`
  box-sizing: border-box;
  width: 446px;
  max-width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;

  ${mobile} {
    width: 100%;
    margin-top: 0;
  }
`;
export const TakeAdmissionInlineFieldsRow = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 8px;

  > div {
    width: 100%;
    flex: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0px;
  }
`;

export const EnrollmentPaymentHistoryContainer = styled.div<{
  $embedded?: boolean;
  $inSuccessPage?: boolean;
  $suppressTopMargin?: boolean;
}>`
  box-sizing: border-box;
  width: 100%;
  margin-top: ${({ $embedded, $inSuccessPage, $suppressTopMargin }) => {
    if ($suppressTopMargin || $inSuccessPage) {
      return '0';
    }
    return $embedded ? '12px' : '16px';
  }};
  margin-bottom: 0;

  ${({ $inSuccessPage }) =>
    $inSuccessPage
      ? css`
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
        `
      : ''}
`;

export const EnrollmentPaymentHistoryStatusIcon = styled.span`
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
  ${mobile} {
    display: none;
  }
`;
export const ReferralCodeFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .applied-text-container {
    padding: 0px !important;
    cursor: auto !important;
  }

  .cursor-not-allowed {
    cursor: not-allowed !important;
    pointer-events: none !important;
  }
`;

export const AppliedText = styled.span`
  background-color: #f1f5f9;
  border-radius: 0px;
  padding: 7.5px;
  color: #16a34a;
`;

export const ApplyButton = styled(Button)`
  background-color: transparent !important;
  border: 1px solid #cbd5e1 !important;
  max-width: 90px !important;
  width: 100% !important;
  height: 38px !important;
  margin-left: 8px;
  margin-top: 4px;
  border-radius: 8px !important;
  color: #16a34a !important;

  > svg {
    color: #16a34a !important;
  }

  ${(props) =>
    props.isDisabled &&
    css`
      color: #94a3b8 !important;
      cursor: not-allowed !important;
    `}

  &.invite-code-applied {
    background-color: #f0fdf4 !important;
    border: 1px solid #86efac !important;
    color: #16a34a !important;
    cursor: default !important;
  }

  @media (max-width: 480px) {
    margin-left: 0px;
    margin-top: 12px;
    width: 100% !important;
    max-width: unset !important;
  }
`;
export const ReferralCodeSuccessMessage = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #22a017;
  margin-left: 8px;
  margin-top: 2px;

  ${({ isActionDiscountConfigApplied }) =>
    isActionDiscountConfigApplied &&
    css`
      font-style: italic;
    `}
`;
export const AlertExclamationMark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid ${colors['light-red-500']};
  color: ${colors['light-red-600']};
  font-family: Inter;
  font-weight: 700;
  font-size: 13px;
  line-height: 1;
  box-sizing: border-box;
`;
export const AlternateCollegeHeading = styled.h3`
  font-family: Inter;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: ${colors['light-blue-gray-800']};
`;

export const AlternateCollegeHint = styled.p`
  margin: 0;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${colors['light-blue-gray-600']};
`;
export const CollegeSelectionSubmitButton = styled(Button)`
  min-width: 120px;
  background-color: ${colors['light-red-800']} !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-family: Inter !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: ${colors['base-white']} !important;
  box-sizing: border-box;

  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
`;
export const SeatReservationPaidBar = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 14px 40px;
  border-radius: 8px;
  background-color: ${colors['light-green-50']};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 18px 0;
  gap: 8px;

  ${maxDeviceWidth(767)} {
    padding: 14px 16px;
  }
`;

export const SeatReservationPaidRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const SeatReservationPaidLabel = styled.span`
  width: 50%;
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${colors['light-blue-gray-500']};
`;

export const SeatReservationPaidValue = styled.span`
  font-family: Inter;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${colors['light-green-800']};
`;

export const SeatUnavailableAlert = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${colors['light-rose-200']};
  display: flex;
  gap: 12px;
  margin-top: 16px;
  align-items: flex-start;

  ${maxDeviceWidth(767)} {
    padding: 12px;
  }
`;

export const SeatUnavailableIconWrap = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
`;

export const SeatUnavailableTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;
export const SeatUnavailableBody = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: ${colors['light-blue-gray-500']};

  strong {
    font-weight: 600;
    color: ${colors['light-blue-gray-800']};
  }
`;
export const SeatUnavailableTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${colors['light-red-800']};
`;

export const SelectAlternateCollegeSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

export const SubmitRow = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 8px;
  box-sizing: border-box;
`;

export const ModalInner = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  padding: 24px;
  max-width: 440px;
  width: 100%;
  background-color: ${colors['base-white']};
  border-radius: 8px;

  ${maxDeviceWidth(767)} {
    padding: 20px 16px;
    max-width: 100%;
  }
`;

export const closeIconWrapperStyles = css`
  top: 0px;
  right: 0px;
  margin: 12px 12px 0px 0px;
`;

/** Positions the enrollment college confirmation modal; replaces former styles.scss overrides. */
export const EnrollmentCollegeConfirmationModalGlobalStyle = createGlobalStyle`
  .baseModalStyles.enrollmentCollegeConfirmationModalStyles {
    width: fit-content;
    max-width: 440px;
    box-sizing: border-box;
    height: fit-content;
    margin: 0 12px;
    padding: 0;
    border-radius: 8px;
    position: relative;
    box-shadow: 0 20px 40px ${colors.black32} !important;

    ${maxDeviceWidth(767)} {
      width: calc(100% - 24px);
      max-width: 420px;
    }
  }

  .baseModalOverlayStyles.enrollmentCollegeConfirmationModalStyles-overlay {
    align-items: center;
  }
`;

export const ModalTitle = styled.h2`
  margin: 0;
  padding-right: 28px;
  font-family: Inter;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: ${colors['light-blue-gray-800']};
`;

export const ModalBodyText = styled.p`
  margin: 0;
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${colors['light-blue-gray-700']};
`;

export const ModalConfirmButton = styled(Button)`
  align-self: center;
  min-width: 160px;
  background-color: ${colors['light-red-800']} !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-family: Inter !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: ${colors['base-white']} !important;
  box-sizing: border-box;

  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
`;
export const EnrollmentOfflineInfoContainer = styled.div`
  width: 100%;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
`;
